
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.css'

export default function Footer() {

    const currentYear = new Date().getFullYear()

    const navigate = useNavigate();

    return <footer>

        <p>
            „Ihr Büro-Profi“ – John Fahrenhorst | Stüheweg 11 | 32549 Bad Oeynhausen
        </p>
       
        <p>
            T +49 (5731) 5 13 30 | F +49 (5731) 53 80 80 | H +49 (0171) 933 0537
        </p>

        <p>
            E-Mail: {' '} 
            <a href="mailto:j.fahrenhorst@bueroprofi.nl">j.fahrenhorst@bueroprofi.nl</a>
        </p>
        
        <p>
            <a className='footerLink' onClick={() => navigate("/impressum")} >Impressum</a>
            {' '} | {' '}
            <a className='footerLink' onClick={() => navigate("/datenschutz")} >Datenschutzerklärung</a>
            
        </p>

        <p className='footer-copyright'>
            © {currentYear}. Alle Rechte vorbehalten.
        </p>

    </footer>

}